import { render, staticRenderFns } from "./uploadAuthArr.vue?vue&type=template&id=708b857a"
import script from "./uploadAuthArr.vue?vue&type=script&lang=js"
export * from "./uploadAuthArr.vue?vue&type=script&lang=js"
import style0 from "./uploadAuthArr.vue?vue&type=style&index=0&id=708b857a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports